<template>
    <div>
        <div class="card" v-if="loading">
            <div class="card-body">
                <p>Loading response data..</p>
            </div>
        </div>
        <div class="row" v-if="responses">
            <div class="col-md-4">
                <div class="card">
                    <div class="card-header px-0 text-center">
                        <h5 class="text-left pl-2 header-title">Responses</h5>
                    </div>
                    <div class="card-body">
                        <div
                            class="d-flex align-items-center justify-content-center"
                        >
                            <h2 class="number-s mb-0 mr-3">
                                {{ responses.overall.responded }} /
                                {{ responses.overall.respondable }}
                            </h2>
                            <i
                                class="far fa-comment brand-primary-gradient"
                                style="font-size: 24px;"
                            ></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card">
                    <div class="card-header px-0 text-center">
                        <h5 class="text-left pl-2 header-title">
                            Response Rate
                        </h5>
                    </div>
                    <div class="card-body">
                        <div
                            class="d-flex align-items-center justify-content-center"
                        >
                            <h2
                                class="number-s mb-0 mr-3"
                                :class="{
                                    'gradient-success':
                                        responses.overall.response_rate >
                                        responses.goal.target / 100,
                                    'gradient-danger':
                                        responses.overall.response_rate + 0.1 <
                                        responses.goal.target / 100
                                }"
                            >
                                {{
                                    responses.overall.response_rate == "-"
                                        ? "-"
                                        : formatRate(
                                              responses.overall.response_rate
                                          ) + "%"
                                }}
                            </h2>
                            <i
                                class="fas fa-chart-line brand-primary-gradient"
                                style="font-size: 24px;"
                            ></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card">
                    <div
                        class="card-header d-flex justify-content-between align-items-center px-0 text-center"
                    >
                        <span></span>
                        <h5 class="text-left pl-2 header-title">Goal</h5>
                        <a
                            class="pr-2 brand-primary-gradient f10"
                            href="#"
                            @click.prevent="toggleGoalEdit"
                        >
                            <span v-if="!editingGoal">
                                <i class="fa fa-pencil-alt"></i>
                                <span>EDIT</span>
                            </span>
                            <span v-else>
                                <i class="fa fa-times"></i>
                                <span>CANCEL</span>
                            </span>
                        </a>
                    </div>
                    <div class="card-body">
                        <div
                            class="d-flex align-items-center justify-content-center"
                        >
                            <h2 class="number-s mb-0 mr-3" v-if="!editingGoal">
                                {{ responses.goal.target }}%
                            </h2>
                            <i
                                class="fa fa-bullseye brand-primary-gradient"
                                style="font-size: 24px;"
                                v-if="!editingGoal"
                            ></i>
                            <div class="d-inline-flex" v-else>
                                <input
                                    class="form-control"
                                    type="text"
                                    v-model="goalValue"
                                />
                                <button
                                    class="btn btn-primary"
                                    @click="storeGoal"
                                    :disabled="savingGoal"
                                >
                                    SAVE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <table
                    class="table-responsive dragscroll gf-table"
                    v-if="responses"
                >
                    <thead>
                        <tr>
                            <th class="empty"></th>
                            <th class="primary">All Sources</th>
                            <th v-for="(source, key) in responses.by_source">
                                <img
                                    :src="
                                        '/assets/img/reviews/' +
                                            imageName(key) +
                                            '.png'
                                    "
                                    :title="sourceLabelFromSlug(key)"
                                    :alt="key"
                                    class="rating-type-image rating-type-image-small"
                                /><br />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="star in 5">
                            <td>
                                <span
                                    >{{ star
                                    }}<i class="far fa-star d-inline"></i
                                ></span>
                            </td>
                            <td class="text-right">
                                <span
                                    v-if="
                                        responses.by_stars[star - 1]
                                            .total_respondable > 0
                                    "
                                    :class="{
                                        'text-danger':
                                            parseFloat(
                                                responses.by_stars[star - 1]
                                                    .response_rate + 0.1
                                            ) <
                                            responses.goal.target / 100,
                                        'text-success':
                                            parseFloat(
                                                responses.by_stars[star - 1]
                                                    .response_rate
                                            ) >
                                            responses.goal.target / 100
                                    }"
                                    >{{
                                        formatRate(
                                            responses.by_stars[star - 1]
                                                .response_rate
                                        )
                                    }}%</span
                                >
                                <span v-else>-</span>
                                <br />
                                <span class="readable-text"
                                    >{{
                                        responses.by_stars[star - 1].responded
                                    }}/{{
                                        responses.by_stars[star - 1]
                                            .total_respondable
                                    }}
                                    <i class="far fa-comment d-inline"></i
                                ></span>
                            </td>
                            <td
                                class="text-right"
                                v-for="(source, key) in responses.by_source"
                            >
                                <span
                                    v-if="
                                        responses.by_source[key][star - 1]
                                            .total_respondable > 0
                                    "
                                    :class="{
                                        'text-danger':
                                            parseFloat(
                                                responses.by_source[key][
                                                    star - 1
                                                ].response_rate + 0.1
                                            ) <
                                            responses.goal.target / 100,
                                        'text-success':
                                            parseFloat(
                                                responses.by_source[key][
                                                    star - 1
                                                ].response_rate
                                            ) >
                                            responses.goal.target / 100
                                    }"
                                    >{{
                                        formatRate(
                                            responses.by_source[key][star - 1]
                                                .response_rate
                                        )
                                    }}%</span
                                >
                                <span v-else>-</span><br />
                                <span class="readable-text"
                                    >{{
                                        responses.by_source[key][star - 1]
                                            .responded
                                    }}/{{
                                        responses.by_source[key][star - 1]
                                            .total_respondable
                                    }}
                                    <i class="far fa-comment d-inline"></i
                                ></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    watch: {
        params: {
            handler(newValue, oldValue) {
                this.fetchResponseData(newValue);
            },
            deep: true
        }
    },
    props: ["user", "teams", "params"],
    data() {
        return {
            responses: null,
            loading: false,
            editingGoal: false,
            goalValue: 0,
            savingGoal: false
        };
    },
    computed: {
        firstRowStats() {
            let rates = [];
            let counts = [];
            let val1 = 0;
            // for (stats of this.responses.by_stars) {
            // 	stats.
            // }
            return 0;
        }
    },
    mounted() {
        this.fetchResponseData(this.params);
    },
    methods: {
        formatRate(num) {
            return (num * 100).toFixed(2);
        },
        fetchResponseData(params) {
            if (!params) {
                return;
            }

            let from = this.params.fromDate;
            let to = this.params.toDate;

            this.loading = true;

            var query = "?fromDate=" + from + "&toDate=" + to;
            axios
                .get(
                    `/api/reporting/${
                        Spark.state.currentTeam.id
                    }/responses${query}`
                )
                .then(response => {
                    var instance = this;
                    setTimeout(function() {
                        instance.responses = response.data;
                        instance.loading = false;
                        instance.goalValue = response.data.goal.target;
                    }, 300);
                });
        },
        toggleGoalEdit() {
            this.editingGoal = !this.editingGoal;
        },
        storeGoal() {
            if (this.goalValue < 0 || this.goalValue > 100) {
                return;
            }
            const payload = {
                type: "response_rate",
                value: this.goalValue
            };
            this.savingGoal = true;
            axios
                .post(
                    `/api/goals/add-generic-goal/${Spark.state.currentTeam.id}`,
                    payload
                )
                .then(response => {
                    this.savingGoal = false;
                    this.editingGoal = false;
                    this.fetchResponseData(this.params);
                    swal("Done!", "Your new goal has been saved.", "success");
                })
                .catch(error => {
                    this.savingGoal = false;
                });
        }
    }
};
</script>